import React, { useContext, useEffect, useState } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError,FinancesDataCreditCheckboxContainer,FinancesDataCreditCheckboxContainerLine,FinancesDataCreditCheckboxContainerSaldo,FinancesDataCreditCheckboxContainerText,FinancesDataCreditCheckboxContainerTitle,FinancesDataCreditLine, FinancesDataCreditLineTitle, FinancesDataNoCredit,
  SaldoTotalRecogerContainer,SaldoTotalRecoger
} from './styles';
import { useForm, Controller } from 'react-hook-form';
import { SessionContext, AgileSimulatorContext } from '../../../store';
import { Form, FormFooterRigth, FormRow } from '../../../components/FormTemplate/styles';
import Select from '../../../components/Select';
import InputIntl from '../../../components/InputIntl';
import { currencyMoney } from '../../../config/currency';
import { DefaultSmallButtonBuscar, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { StepFourDisplayValuesRow, StepFourDisplayValuesRowValue } from '../../Simulator/Result/styles';
import { StepFourColumn, StepFourDisplayValues, StepFourDisplayResultLabel } from './styles';
import { formatPrice } from '../../../helpers/price';
import { getAgileLineasDeCredito, getAgileSimulatorCreditBound, getAgileSimulatorTasas, postAgileSimulatorResult } from '../../../services/agileSimulator';
import infoCircle from '../../../assets/images/info-circle.svg';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import { BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import { handleChangeIdentification } from '../../../helpers/price';
import { identificationType } from '../../../helpers/enum';
import { getCreditsByAdvisor } from '../../../services/credit';
import Buscar from '../../../assets/images/buscar.svg';
import {creditLinesBack} from '../../../helpers/enum';
import InputCheckbox from '../../../components/InputCheckbox';
import { getIdentificationTypes } from '../../../services/calculator';

const SimuladorRetanqueo = ({ setActiveStep, setLastStep }) => {
  const { simulator, setSimulator } = useContext(AgileSimulatorContext);
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({});
  const fields = watch();
  const [isLoading, setIsLoading] = useState(false);
  const [tipoDocumento, setTipoDocumentos] = useState([]);
  const [showTipoDocumentos, setShowTipoDocumentos] = useState(false);
  const [tipoIdentificacion, setTipoIdentificacion] = useState({});
  const [identificacion, setIdentificacion] = useState('');
  const [clientDataSearchErrorVisible, setClientDataSearchErrorVisible] = useState("");
  const [creditsByAcesor, setCreditsByAcesor] = useState([]);
  const [isCreditsByAcesor, setIsCreditsByAcesor] = useState(false);
  const [clientDataSearchError, setClientDataSearchError] = useState('No se pudieron obtener los datos del cliente');
  const [creditosSeleccionados, setCreditosSeleccionados] = useState([]);

  async function calculateData(dataa) {
    try {
      setIsLoading(true);
      
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }

  }

  async function initializeStateComponent() {
    try {
      setIdentificationRadioChecked({"id":"CC","nombre":"Cédula de ciudadanía","label":"CC","value":"CC"})
      const identificationTypes = await getIdentificationTypes();
      setTipoDocumentos(identificationTypes.data);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  function setIdentificationRadioChecked(radio) {
    if(radio.value !== tipoIdentificacion.value){
      setValue('identificacion', '');
    }
    setTipoIdentificacion(radio)
  }

  function onChangeIdentification(e) {
    var identificacion = undefined;
    if (simulator.clientData.tipoIdentificacion.value === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    setValue('identificacion', identificacion); 
    setIdentificacion(identificacion);
    setClientDataSearchErrorVisible(false);
  }

  async function getCredits() {
    const data = {
      tipoIdentificacion: tipoIdentificacion?.id,
      identificacion: fields.identificacion.replaceAll('.', '')
    }

    setIsLoading(true);
    const credits = await getCreditsByAdvisor(data, 0);
    setIsLoading(false);
    setCreditsByAcesor(credits.data);
    if(credits.data.length > 0){
      setClientDataSearchErrorVisible(false)
    }else {
      setClientDataSearchError('El cliente no cuenta con creditos activos')
      setClientDataSearchErrorVisible(true)
    }
    
    setIsCreditsByAcesor(true);
  }

  function getListofCredits() {
    return (simulator.financesData.credits.length === undefined) ? [simulator.financesData.credits] : simulator.financesData.credits;
  }

  function setCreditToStore(credit) {
      const newCredit = {
        id: credit.id,
        numeroRadicacion: credit.numeroRadicacion,
        saldoAlDia: credit.saldoAlDia
      }
      const filtered = creditosSeleccionados.filter(credito => credito.id === credit.id);
      if (filtered.length > 0) {
        const newCreditList = creditosSeleccionados.filter(credito => credito.id !== credit.id);
        setCreditosSeleccionados(newCreditList)
      } else {
        setCreditosSeleccionados([...creditosSeleccionados.filter(credito => credito.id !== undefined), newCredit])
      }
  }

  function verifyCheckbox(checkbox) {
    let res = false;
    creditosSeleccionados.forEach(item => {
      if (item.id === checkbox.id) {
        res = true;
        return;
      }
    });
    return res;
  }

  return (
    <div style={{ padding: '40px', paddingTop: '0px' }}>
      <Form onSubmit={handleSubmit(calculateData)}>
      <FormRow col="3">
            <Select
              error={errors.tipoDocumento}
              setShow={setShowTipoDocumentos}
              show={showTipoDocumentos}
              defaultValue={tipoIdentificacion?.nombre}
              setSelected={setIdentificationRadioChecked}
              list={tipoDocumento}
              placeholder="Seleccionar..."
              label="Tipo de documento"
              name="tipoIdentificacion"
              id="tipoIdentificacion"
              register={register({ required: "Este dato es obligatorio" })}
            />
            <Controller
              name="identificacion"
              control={control}
              value={identificacion}
              render={() => (
                <InputDefault
                  name="identificacion"
                  label="Número de documento de identidad"
                  register={register({
                    required: "Este dato es obligatorio",
                    pattern: {
                      value: /^\d+(\.\d+)*$/,
                      message: "Error en el número, ingresa uno válido",
                    }
                  })}
                  id="identificacion"
                  error={errors.identificacion}
                  maxLength={tipoIdentificacion.value === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                  minLength={tipoIdentificacion.value === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                  onChange={onChangeIdentification}
                  onBlur={() => getCredits()}
                />
              )}
            />
            <ClientDataSearchColumn>
              <ClientDataSearchError visible={clientDataSearchErrorVisible}>{clientDataSearchError}</ClientDataSearchError>
              <DefaultSmallButtonBuscar type="button" id="load-client-data" onClick={getCredits}> <img src={Buscar} alt="button"></img> </DefaultSmallButtonBuscar>
            </ClientDataSearchColumn>
              
          </FormRow>
          {creditsByAcesor.length > 0 ? (
            <FinancesDataCreditLine>
              <FinancesDataCreditLineTitle>Créditos activos</FinancesDataCreditLineTitle>
              <FinancesDataCreditCheckboxContainerLine>
                {!isLoading ? (
                  creditsByAcesor.length ? (
                    creditsByAcesor.map((item, key) => (
                      <FinancesDataCreditCheckboxContainer>
                         <InputCheckbox onClick={() => setCreditToStore(item)}
                          checked={verifyCheckbox(item)}
                          value={item.numeroRadicacion} />
                        <FinancesDataCreditCheckboxContainerText><FinancesDataCreditCheckboxContainerTitle>Pagaduría:</FinancesDataCreditCheckboxContainerTitle>{item.pagaduria.nombre}</FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerText>Saldo al día:</FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerSaldo>$ {formatPrice(parseInt(item.saldoAlDia))}</FinancesDataCreditCheckboxContainerSaldo>
                        <FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerTitle>Cuota a retanquear:</FinancesDataCreditCheckboxContainerTitle>
                        <FinancesDataCreditCheckboxContainerTitle>$ {formatPrice(parseInt(item.cuota))}</FinancesDataCreditCheckboxContainerTitle>
                        </FinancesDataCreditCheckboxContainerText>
                      </FinancesDataCreditCheckboxContainer>
                    ))
                  ) : (
                    simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id ? (
                      <FinancesDataNoCredit>Cliente no tiene creditos activos, selecciona otra modalidad de crédito</FinancesDataNoCredit>
                    ) : (
                      <FinancesDataNoCredit>Cliente no tiene creditos activos</FinancesDataNoCredit>
                    )
                  )) : ''}
              </FinancesDataCreditCheckboxContainerLine>
              {!isLoading && creditsByAcesor.length ? (
                <SaldoTotalRecoger>
                  <SaldoTotalRecogerContainer>Saldo total a recoger</SaldoTotalRecogerContainer>
                  <SaldoTotalRecogerContainer>$ {formatPrice(parseInt(creditosSeleccionados.reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) || 0)}</SaldoTotalRecogerContainer>
                </SaldoTotalRecoger>
              ) : ''}
            </FinancesDataCreditLine>
          ) : ''}
      
        {isLoading && <Loader></Loader>}
      </Form>

    </div >
  )
}

export default SimuladorRetanqueo
